module.exports = __webpack_public_path__ + "static/projectjob-b7d889f1ea15366d3b690c92189d39ff.png";